import InitialState from '../initial-state';
import * as ActionName from '../action-names';
import ButtonTypes from '../../components/main/strip-framework/strips/cashoutable-bets-strip/cash-out-box/cash-out-box-components/cash-out-button/button-types';

export default function homeReducer(state = InitialState.getState().homePage, action) {
  switch (action.type) {
    case ActionName.KEYS_STRIP_COMPONENTS_COMPUTED:
      return Object.assign({}, state, { keysForStripComponents: action.data });
    case ActionName.DATA_CASHOUTABLE_BETS_STRIP_LOADED:
      return Object.assign({}, state, { cashoutableBets: action.data });
    case ActionName.CASH_IN_BET_SUCCESS: {
      const newCashoutableBets = state.cashoutableBets.slice();
      const { singleBetId } = action.data;
      const indexOfCashedOutCoupon = newCashoutableBets.findIndex(item => item.singleBetId === singleBetId);

      newCashoutableBets[indexOfCashedOutCoupon] = {
        ...newCashoutableBets[indexOfCashedOutCoupon],
        'isCashedIn': true
      };

      return Object.assign({}, state, { cashoutableBets: newCashoutableBets });
    }

    case ActionName.REMOVE_CASHED_IN_BET: {
      let newCashoutableBets = state.cashoutableBets
        .slice()
        .filter((item) => item.isCashedIn !== true);

      return Object.assign({}, state, { cashoutableBets: newCashoutableBets });
    }

    case ActionName.CASH_IN_BET_FAIL: {

      const newCashoutableBets = state.cashoutableBets.slice();
      const { singleBetId } = action.data;
      const indexOfCashedOutCoupon = newCashoutableBets.findIndex(item => item.singleBetId === singleBetId);

      newCashoutableBets[indexOfCashedOutCoupon] = {
        ...newCashoutableBets[indexOfCashedOutCoupon],
        'cashOutButtonType': ButtonTypes.rejected
      };

      return Object.assign({}, state, { cashoutableBets: newCashoutableBets });
    }

    case ActionName.SWITCH_BUTTON_TYPE : {

      const newCashoutableBets = state.cashoutableBets.slice();
      const { btnType, couponId } = action.data;
      const indexOfCashedOutCoupon = newCashoutableBets.findIndex(item => item.id === couponId);

      newCashoutableBets[indexOfCashedOutCoupon] = {
        ...newCashoutableBets[indexOfCashedOutCoupon],
        'cashOutButtonType': btnType
      };

      return Object.assign({}, state, { cashoutableBets: newCashoutableBets });
    }
    default:
      return state;
  }
}
